import { useMutation } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { getZapsCheckoutSessionUrl } from '../subscription.service';
export const useGetZapsCheckoutUrl = (subdomain = getSubdomain()) => {
    return useMutation({
        mutationFn: () => getZapsCheckoutSessionUrl(subdomain),
    });
};
